/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { TAG_COLORS } from "~/constants";
import { QueryStateFilterValue } from "~/hooks";
import { formatShortDate, isNotEmpty } from "~/tools";

const DANGER_TAGS = ["waste", "unassigned", "co2eWaste"];

function capitalize(input: string) {
  return input.charAt(0).toUpperCase() + input.slice(1);
}

export function getColor(key: string) {
  if (DANGER_TAGS.includes(key)) {
    return TAG_COLORS.danger;
  }
  return undefined;
}

const FILTER_LABEL: Record<string, string> = {
  waste: "Estate Records with Savings Suggestions",
  unassigned: "Unallocated Estate Records",
  external: "Estate Records from External Integrations",
  enrichment: "Estate Records with Enrichments",
  co2eWaste: "Estate Records with Carbon Emissions Savings",
};

export function getLabel(key: string, value: QueryStateFilterValue) {
  if (Array.isArray(value) && isNotEmpty(value)) {
    switch (key) {
      case "provider":
        return `Provider: ${value.join(", ")}`;
      case "typeSubtype":
        return `Resource type: ${value.length} selected`;
      case "account":
        return `Cloud account: ${value.length} selected`;
      case "externalIntegration":
        return `External Integration: ${value.length} selected`;
      case "wastePolicy":
        return `Savings Suggestions policy: ${value.length} selected`;
      case "enrichmentIntegrationId":
        return `Enriched by: ${value.length} selected External Integrations`;
      default:
        return `${capitalize(key)}: ${value.length} selected`;
    }
  }

  switch (true) {
    case key.startsWith("cost"):
      return `${key.endsWith("From") ? "Cost from" : "Cost to"}: ${value}`;
    case key === "assignmentUpdatedFrom":
      return `Unallocated From: ${formatShortDate(value as string) ?? ""}`;
    case key === "assignmentUpdatedTo":
      return `Unallocated To: ${formatShortDate(value as string) ?? ""}`;
    default:
      return FILTER_LABEL[key] ?? `${capitalize(key)}: ${value}`;
  }
}
